<template>
  <div class="wallet-list-page">
    <van-nav-bar class="wallet-list-nav" :fixed="true" left-arrow placeholder :title="$t('bankAccount.title')"
      @click-left="$router.go(-1)" />

    <div class="wallet-list-content">
      <div class="add-account" @click="handleFind()">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="9"></circle>
          <path d="M12 8v8M8 12h8"></path>
        </svg>
        <span>{{ $t("bankAccount.addAccount") }}</span>
      </div>

      <div class="account-list">
        <div v-for="(item, index) in dataList" :key="item.id || index" class="account-card" @click="handleFind(item)">
          
          <p>
            <span class="account-card__label">{{ $t("bankAccount.bank") }}</span>
            <span>{{ item.bank }}</span>
          </p>
          <p>
            <span class="account-card__label">{{ $t("bankAccount.accountName") }}</span>
            <span>{{ item.name }}</span>
          </p>
          <p>
            <span class="account-card__label">{{ $t("bankAccount.accountNumber") }}</span>
            <span>{{ item.card }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavBar, Toast } from "vant";
import { GET_USERS_BANK } from "@/api";

export default {
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.getLists();
  },
  methods: {
    handleFind(item) {
      if (!item) {
        this.$router.push("/add-bank-card");
        return;
      }
      this.$router.push({
        path: "/add-bank-card",
        query: { id: item.id },
      });
    },
    async getLists() {
      this.dataList = [];
      Toast.loading({
        forbidClick: true,
        duration: 0,
      });
      try {
        const response = await GET_USERS_BANK();
        const { data, msg, ret } = response.data;
        if (ret !== 1) {
          this.$toast(msg);
          return;
        }
        this.dataList = data || [];
      } catch (error) {
        console.error("Failed to load bank accounts:", error);
      } finally {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wallet-list-page {
  min-height: 100vh;
  background: var(--page-background);
}

.wallet-list-content {
  padding: calc(12rem / 16) calc(14rem / 16) calc(36rem / 16);
}

.add-account {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  align-items: center;
  padding: calc(18rem / 16) calc(20rem / 16);
  border: 0;
  border-radius: calc(12rem / 16);
  background: #fff;
  box-shadow: 0 calc(4rem / 16) calc(12rem / 16) rgba(0, 0, 0, 0.05);
  color: var(--color-primary-strong);
  font-size: calc(17rem / 16);
  font-weight: 600;
  text-align: left;

  svg {
    width: calc(22rem / 16);
    height: calc(22rem / 16);
    margin-right: calc(13rem / 16);
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    stroke-linecap: round;
  }
}

.account-list {
  margin-top: calc(12rem / 16);
}

.account-card {
  padding: calc(20rem / 16) calc(18rem / 16);
  border-radius: calc(12rem / 16);
  background: #fff;
  box-shadow: 0 calc(4rem / 16) calc(12rem / 16) rgba(0, 0, 0, 0.04);
  color: #777;

  &+& {
    margin-top: calc(12rem / 16);
  }

  p {
    display: flex;
    margin: calc(3rem / 16) 0 0;
    color: #7f7f7f;
    font-size: calc(15rem / 16);
    line-height: 1.45;
    word-break: break-all;
  }
}

.account-card__heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: calc(6rem / 16);
  color: #7a7a7a;
  font-size: calc(17rem / 16);
  font-weight: 600;
  line-height: 1.4;
}

.account-card__label {
  flex-shrink: 0;
  margin-right: calc(5rem / 16);
}

.default-badge {
  display: inline-flex;
  width: calc(29rem / 16);
  height: calc(29rem / 16);
  align-items: center;
  justify-content: center;
  margin-left: calc(14rem / 16);
  border-radius: calc(8rem / 16);
  background: var(--color-primary-soft);

  svg {
    width: calc(19rem / 16);
    height: calc(19rem / 16);
    fill: none;
    stroke: var(--color-primary-strong);
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
}

/deep/ .wallet-list-nav.van-nav-bar,
/deep/ .wallet-list-nav .van-nav-bar {
  background: var(--color-surface);
}

/deep/ .wallet-list-nav .van-nav-bar__title,
/deep/ .wallet-list-nav .van-icon {
  color: var(--color-text);
}
</style>
